export enum Distribution {
  TakeAway = 1,
  Delivery = 2,
  OnLocation = 3,
}